import {createStore} from 'redux';
import rootReducer from './rootReducer';

const initialRootState = {}

const store = createStore(rootReducer,initialRootState);
export default store;